<template>
  <div class="profile_wrapper most_profile driver_profile_hero">
    <!-- HERO HEADER BANNER -->
    <div class="creative_hero_banner" v-if="data.userInfo">
      <div class="particles_bg">
        <vue-particles
          color="#ffffff"
          :particleOpacity="0.6"
          :particlesNumber="140"
          shapeType="circle"
          :particleSize="3.5"
          linesColor="#ffffff"
          :linesWidth="1"
          :lineLinked="true"
          :lineOpacity="0.25"
          :linesDistance="110"
          :moveSpeed="3.5"
          :hoverEffect="true"
          :clickEffect="true"
          hoverMode="repulse"
          clickMode="push"
        ></vue-particles>
      </div>

      <!-- Glowing Ambient Spheres -->
      <div class="hero_glow_sphere glow_1"></div>
      <div class="hero_glow_sphere glow_2"></div>

      <!-- Hero Header Content -->
      <div class="hero_header_content">
        <div class="avatar_and_info">
          <!-- Avatar with Gradient Ring -->
          <div class="avatar_ring">
            <img
              :src="
                data.userInfo.image ||
                require('@/assets/images/Avatars/user.jpg')
              "
              alt="Avatar"
              class="driver_avatar_img"
            />
            <span
              class="status_online_dot"
              :class="{
                is_active:
                  data.userInfo.is_admin_active_user && !data.userInfo.is_ban,
              }"
              :title="
                data.userInfo.is_admin_active_user && !data.userInfo.is_ban
                  ? 'نشط'
                  : 'غير نشط'
              "
            ></span>
          </div>

          <!-- Driver Details Column -->
          <div class="driver_details_col">
            <div class="name_row">
              <h2 class="driver_name">
                <router-link :to="'/users/show/' + data.userInfo.id">
                  {{ data.userInfo.full_name }}
                </router-link>
              </h2>
              <button
                class="chat_action_btn"
                @click="isChatOpen = true"
                title="بدء محادثة مع السائق"
              >
                <i class="fal fa-comments"></i>
                <span class="chat_btn_text">محادثة</span>
              </button>
            </div>

            <!-- Quick Meta Tags -->
            <div class="quick_meta_row">
              <span class="meta_pill" v-if="data.userInfo.phone">
                <i class="fal fa-phone-alt"></i>
                {{ data.userInfo.phone }}
              </span>
              <span class="meta_pill" v-if="data.userInfo.email">
                <i class="fal fa-envelope"></i>
                {{ data.userInfo.email }}
              </span>
              <span
                class="meta_pill status_badge"
                :class="data.userInfo.is_ban ? 'banned' : 'active'"
              >
                <i
                  :class="
                    data.userInfo.is_ban
                      ? 'fal fa-user-slash'
                      : 'fal fa-check-circle'
                  "
                ></i>
                {{ data.userInfo.is_ban ? "حساب محظور" : "حساب نشط" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LOADER STATE -->
    <transition name="fadeInUp" mode="out-in" v-if="!data.userInfo">
      <MainLoader />
    </transition>

    <!-- ACTION CONTROL BAR & ROUTER VIEW -->
    <template v-else>
      <div class="action_toolbar_wrapper my-4">
        <div class="toolbar_inner_card">
          <div class="toolbar_title_col">
            <i class="fal fa-sliders-h"></i>
            <span>الإجراءات السريعة</span>
          </div>

          <div class="toolbar_actions_group">
            <!-- Edit Driver Link -->
            <router-link
              :to="`/driver/edit/${id}`"
              class="toolbar_btn btn_edit"
            >
              <i class="fal fa-user-edit"></i>
              <span>تعديل بيانات السائق</span>
            </router-link>

            <!-- Transfer Balance Button -->
            <button
              class="toolbar_btn btn_balance"
              :disabled="balanceLoading"
              @click="isChangeBalanceModel = true"
            >
              <i class="fal fa-wallet"></i>
              <span>تحويل رصيد</span>
            </button>

            <!-- Driver Acceptance Button -->
            <button
              class="toolbar_btn"
              :class="
                data.userInfo?.is_admin_active_user
                  ? 'btn_success'
                  : 'btn_warning'
              "
              @click="toggleacceptModel"
            >
              <i
                :class="
                  data.userInfo?.is_admin_active_user
                    ? 'fal fa-user-check'
                    : 'fal fa-user-clock'
                "
              ></i>
              <span>
                {{
                  data.userInfo?.is_admin_active_user
                    ? "بيانات السائق مقبولة"
                    : "بيانات السائق غير مقبولة"
                }}
              </span>
            </button>

            <!-- Ban / Unban Button -->
            <button
              class="toolbar_btn"
              :class="
                !data.userInfo.is_ban ? 'btn_active_status' : 'btn_danger'
              "
              @click="toggleStatusModel"
            >
              <i
                :class="
                  !data.userInfo.is_ban ? 'fal fa-shield-check' : 'fal fa-ban'
                "
              ></i>
              <span>{{ data.userInfo.is_ban ? "محظور" : "غير محظور" }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- ROUTER VIEW FOR CHILD CARDS -->
      <router-view :userInfo="data.userInfo"> </router-view>
    </template>

    <!-- DIALOG MODALS -->
    <v-dialog v-model="statusModel" width="500">
      <v-card class="p-4 custom_dialog_card" v-if="data.userInfo">
        <div class="dialog_header text-center mb-3">
          <div
            class="dialog_icon_box"
            :class="!data.userInfo.is_ban ? 'icon_danger' : 'icon_success'"
          >
            <i
              :class="
                !data.userInfo.is_ban ? 'fal fa-user-lock' : 'fal fa-user-check'
              "
            ></i>
          </div>
          <h5 class="mt-3 font-weight-bold" v-if="data.userInfo.is_ban">
            هل تود فك حظر هذا السائق؟
          </h5>
          <h5 class="mt-3 font-weight-bold" v-else>هل تود حظر هذا السائق؟</h5>
        </div>

        <textarea
          v-if="!data.userInfo.is_ban"
          v-model="deactive_reason"
          placeholder="اكتب سبب الحظر هنا..."
          class="deactive_reason mt-3 px-3 py-2 form-control custom_textarea"
        ></textarea>

        <div class="d-flex justify-content-center gap-3 mt-4">
          <v-btn
            class="px-8 rounded-pill text-white font-weight-bold"
            @click="changeStatus"
            :loading="statusLoading"
            :color="!data.userInfo.is_ban ? 'error' : 'success'"
          >
            نعم
          </v-btn>
          <v-btn
            class="px-8 rounded-pill font-weight-bold"
            @click="statusModel = false"
            outlined
            color="grey darken-1"
          >
            إلغاء
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="acceptModel" width="500">
      <v-card class="p-4 custom_dialog_card" v-if="data.userInfo">
        <div class="dialog_header text-center mb-3">
          <div
            class="dialog_icon_box"
            :class="
              data.userInfo.is_admin_active_user
                ? 'icon_warning'
                : 'icon_success'
            "
          >
            <i
              :class="
                data.userInfo.is_admin_active_user
                  ? 'fal fa-exclamation-triangle'
                  : 'fal fa-user-check'
              "
            ></i>
          </div>
          <h5
            class="mt-3 font-weight-bold"
            v-if="!data.userInfo?.is_admin_active_user"
          >
            هل تود قبول بيانات هذا السائق؟
          </h5>
          <h5 class="mt-3 font-weight-bold" v-else>
            هل تود إلغاء قبول بيانات هذا السائق؟
          </h5>
        </div>

        <div
          class="d-flex justify-content-center gap-3 mt-4"
          v-if="data.userInfo"
        >
          <v-btn
            class="px-8 rounded-pill text-white font-weight-bold"
            @click="changeAcceptStatus"
            :color="data.userInfo.is_admin_active_user ? 'error' : 'success'"
            :loading="acceptLoading"
          >
            نعم
          </v-btn>
          <v-btn
            class="px-8 rounded-pill font-weight-bold"
            @click="acceptModel = false"
            outlined
            color="grey darken-1"
          >
            إلغاء
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isChangeBalanceModel" width="450">
      <v-card class="p-4 custom_dialog_card">
        <form @submit.prevent="toggleBalance">
          <div class="dialog_header text-center mb-4">
            <div class="dialog_icon_box icon_info">
              <i class="fal fa-coins"></i>
            </div>
            <h5 class="main_color font-weight-bold mt-2">تحويل رصيد</h5>
          </div>

          <div class="input_wrapper top_label mb-3">
            <label class="form-label">نوع التحويل</label>
            <multiselect
              v-model="transaction.type"
              :options="types"
              label="name"
              track-by="name"
              placeholder="اختر نوع المعاملة"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
            ></multiselect>
          </div>

          <div class="input_wrapper top_label mb-3">
            <input
              step="any"
              type="number"
              class="form-control custom_input"
              v-model="transaction.amount"
              placeholder="أدخل المبلغ"
            />
            <label class="form-label">المبلغ</label>
          </div>

          <div class="input_wrapper top_label mb-3">
            <input
              type="text"
              class="form-control custom_input"
              v-model="transaction.note"
              placeholder="ملاحظات إضافية"
            />
            <label class="form-label">الملاحظة</label>
          </div>

          <div class="input_wrapper top_label mb-4">
            <textarea
              class="form-control custom_textarea"
              placeholder="السبب..."
              v-model="transaction.reason"
            />
            <label class="form-label">السبب</label>
          </div>

          <div class="d-flex justify-content-center gap-3">
            <v-btn
              depressed
              color="success"
              class="px-10 rounded-pill font-weight-bold text-white"
              :loading="balanceLoading"
              type="submit"
            >
              تأكيد التحويل
            </v-btn>
            <v-btn
              outlined
              color="grey darken-1"
              class="px-6 rounded-pill font-weight-bold"
              @click="isChangeBalanceModel = false"
            >
              إلغاء
            </v-btn>
          </div>
        </form>
      </v-card>
    </v-dialog>

    <FloatingChat
      v-if="isChatOpen"
      :userId="id"
      :userType="'driver'"
      :userName="data.userInfo ? data.userInfo.full_name : ''"
      :userAvatar="data.userInfo ? data.userInfo.image : ''"
      @close="isChatOpen = false"
    />
  </div>
</template>

<script>
import FloatingChat from "@/components/Chat/FloatingChat.vue";

export default {
  components: { FloatingChat },
  props: ["id"],

  data() {
    return {
      isChatOpen: false,
      data: {
        userInfo: null,
        loading: false,
      },
      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      rejectedReason: "",

      deleteModalIsOpen: false,
      deleteItemToShow: null,

      // ========== Your Data

      // ========== Loading
      loading: false,
      reportReasonToShow: null,
      btnIsLoading: false,
      e1: 1,
      statusModel: false,
      deactive_reason: null,
      statusLoading: false,
      acceptLoading: false,
      acceptModel: false,
      // acceptLoading: false,
      isChangeBalanceModel: false,
      balanceLoading: false,
      transaction: {
        type: null,
        amount: null,
        note: null,
        reason: null,
      },
      types: [
        {
          id: "withdraw",
          name: "سحب",
        },
        {
          id: "charge",
          name: "ايداع",
        },
      ],
    };
  },

  methods: {
    toggleBalance() {
      this.balanceLoading = true;
      if (!this.transaction.type) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل نوع التحويل",
          position: "bottomCenter",
        });
        this.balanceLoading = false;
        return;
      } else if (!this.transaction.amount) {
        this.$iziToast.error({
          timeout: 2000,
          message: "يرجى ادخال المبلغ",
          position: "bottomCenter",
        });
        this.balanceLoading = false;
        return;
      }
      const formDta = new FormData();
      // formDta.append("type", this.transaction.type.id);

      formDta.append("amount", this.transaction.amount);
      if (this.transaction.note) {
        formDta.append("note", this.transaction.note);
      }
      if (this.transaction.reason) {
        formDta.append("reason", this.transaction.reason);
      }

      this.$axios
        .post(`${this.transaction.type.id}/${this.data.userInfo.id}`, formDta)
        .then((res) => {
          this.balanceLoading = false;
          this.isChangeBalanceModel = false;
          this.transaction.amount = null;
          this.transaction.type = null;
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomCenter",
          });
          // location.reload();
          this.setRows();
        })
        .catch((err) => {
          this.balanceLoading = false;
          // this.isChangeBalanceModel = false;
          // this.transaction.amount = null;
          // this.transaction.type = null;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomCenter",
          });
        });
    },
    toggleacceptModel() {
      this.acceptModel = true;
    },
    changeAcceptStatus() {
      this.acceptLoading = true;
      const formData = new FormData();

      formData.append(
        "is_admin_active_user",
        !this.data.userInfo.vehicle.is_admin_active ||
          !this.data.userInfo.vehicle.is_owner_active
          ? 1
          : 0
      );
      // if (this.deactive_reason) {
      //   formData.append("message", this.deactive_reason);
      // }
      formData.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `/driver/adminStatus/${this.data.userInfo.id}`,
        data: formData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.acceptModel = false;
          this.acceptLoading = false;
          this.setRows();
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
          this.acceptLoading = false;
        });
    },
    toggleStatusModel() {
      this.statusModel = true;
    },
    changeStatus() {
      if (!this.data.userInfo.is_ban && !this.deactive_reason) {
        this.$iziToast.error({
          message: "يرجي ادخال سبب الحظر اولا",
          timeout: 5000,
          position: "bottomRight",
        });
        return;
      }
      this.statusLoading = true;
      const formData = new FormData();
      formData.append("is_active", this.data.userInfo.is_ban ? 0 : 1);
      if (this.deactive_reason) {
        formData.append("message", this.deactive_reason);
      }
      formData.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `/driver/is_active/${this.data.userInfo.id}`,
        data: formData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.statusModel = false;
          this.setRows();
          this.statusLoading = false;
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
          this.statusLoading = false;
        });
    },
    // ===== Toggle Delete Modal =====
    toggleDeleteModal(item) {
      this.deleteItemToShow = item;

      this.deleteModalIsOpen = !this.deleteModalIsOpen;
    },
    getData() {
      this.data.loading = true;
      this.$axios({
        method: "GET",
        url: `driver/${this.id}`,
      })
        .then((res) => {
          this.data.userInfo = res.data.data;
          this.data.userInfo.loading = false;

          this.data.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.data.loading = false;
        });
    },
  },

  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.driver_profile_hero {
  /* HERO HEADER BANNER */
  .creative_hero_banner {
    position: relative;
    border-radius: 28px;
    background: linear-gradient(
      135deg,
      #5b2857 0%,
      var(--mainColor-2, #783d73) 55%,
      #9c4b96 100%
    );
    box-shadow: 0 20px 40px -10px rgba(120, 61, 115, 0.35);
    overflow: hidden;
    padding: 35px 35px;
    margin-bottom: 25px;
    color: #ffffff;

    .particles_bg {
      position: absolute;
      inset: 0;
      z-index: 1;

      #particles-js {
        height: 100%;
        width: 100%;
      }
    }

    .hero_glow_sphere {
      position: absolute;
      border-radius: 50%;
      filter: blur(50px);
      pointer-events: none;
      z-index: 1;

      &.glow_1 {
        top: -60px;
        left: -60px;
        width: 200px;
        height: 200px;
        background: rgba(200, 70, 227, 0.35);
      }

      &.glow_2 {
        bottom: -60px;
        right: 10%;
        width: 240px;
        height: 240px;
        background: rgba(120, 61, 115, 0.4);
      }
    }

    .hero_header_content {
      position: relative;
      z-index: 2;

      .avatar_and_info {
        display: flex;
        align-items: center;
        gap: 24px;
        flex-wrap: wrap;

        .avatar_ring {
          position: relative;
          width: 110px;
          height: 110px;
          border-radius: 50%;
          padding: 4px;
          background: linear-gradient(
            135deg,
            #ffffff 0%,
            rgba(255, 255, 255, 0.4) 100%
          );
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.25);
          flex-shrink: 0;

          .driver_avatar_img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
            background: #ffffff;
          }

          .status_online_dot {
            position: absolute;
            bottom: 4px;
            right: 4px;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #ef4444;
            border: 3px solid #ffffff;
            box-shadow: 0 0 10px rgba(239, 68, 68, 0.8);

            &.is_active {
              background: #10b981;
              box-shadow: 0 0 10px rgba(16, 185, 129, 0.8);
            }
          }
        }

        .driver_details_col {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .name_row {
            display: flex;
            align-items: center;
            gap: 16px;
            flex-wrap: wrap;

            .driver_name {
              margin: 0;
              font-weight: 800;
              font-size: 1.6rem;

              a {
                color: #ffffff !important;
                text-decoration: none;
                transition: opacity 0.2s ease;

                &:hover {
                  opacity: 0.9;
                }
              }
            }

            .chat_action_btn {
              display: inline-flex;
              align-items: center;
              gap: 8px;
              padding: 8px 18px;
              border-radius: 50px;
              background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
              color: #ffffff;
              border: none;
              font-weight: 700;
              font-size: 0.9rem;
              box-shadow: 0 6px 16px rgba(245, 158, 11, 0.35);
              transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
              cursor: pointer;

              &:hover {
                transform: translateY(-2px) scale(1.04);
                box-shadow: 0 10px 22px rgba(245, 158, 11, 0.5);
              }
            }
          }

          .quick_meta_row {
            display: flex;
            align-items: center;
            gap: 12px;
            flex-wrap: wrap;

            .meta_pill {
              display: inline-flex;
              align-items: center;
              gap: 6px;
              padding: 5px 14px;
              border-radius: 50px;
              background: rgba(255, 255, 255, 0.15);
              backdrop-filter: blur(10px);
              font-size: 0.825rem;
              font-weight: 500;
              color: rgba(255, 255, 255, 0.95);

              &.status_badge {
                font-weight: 700;

                &.active {
                  background: rgba(16, 185, 129, 0.25);
                  color: #6ee7b7;
                }

                &.banned {
                  background: rgba(239, 68, 68, 0.25);
                  color: #fca5a5;
                }
              }
            }
          }
        }
      }
    }
  }

  /* ACTION TOOLBAR BAR */
  .action_toolbar_wrapper {
    .toolbar_inner_card {
      background: #ffffff;
      border-radius: 20px;
      border: 1px solid rgba(226, 232, 240, 0.9);
      padding: 16px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;
      box-shadow: 0 8px 20px -5px rgba(15, 23, 42, 0.05);

      .toolbar_title_col {
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 700;
        color: #334155;
        font-size: 1rem;

        i {
          color: var(--mainColor-2, #783d73);
          font-size: 1.1rem;
        }
      }

      .toolbar_actions_group {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;

        .toolbar_btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          border-radius: 14px;
          border: none;
          font-size: 0.875rem;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
          text-decoration: none !important;

          &.btn_edit {
            background: rgba(120, 61, 115, 0.12);
            color: var(--mainColor-2, #783d73);
            border: 1px solid rgba(120, 61, 115, 0.3);

            &:hover {
              background: var(--mainColor-2, #783d73);
              color: #ffffff;
              transform: translateY(-2px);
              box-shadow: 0 8px 18px rgba(120, 61, 115, 0.3);
            }
          }

          &.btn_balance {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            color: #ffffff;
            box-shadow: 0 6px 15px rgba(16, 185, 129, 0.25);

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 10px 20px rgba(16, 185, 129, 0.35);
            }
          }

          &.btn_success {
            background: rgba(16, 185, 129, 0.12);
            color: #059669;
            border: 1px solid rgba(16, 185, 129, 0.3);

            &:hover {
              background: #059669;
              color: #ffffff;
            }
          }

          &.btn_warning {
            background: rgba(245, 158, 11, 0.12);
            color: #d97706;
            border: 1px solid rgba(245, 158, 11, 0.3);

            &:hover {
              background: #d97706;
              color: #ffffff;
            }
          }

          &.btn_active_status {
            background: rgba(99, 102, 241, 0.12);
            color: #4f46e5;
            border: 1px solid rgba(99, 102, 241, 0.3);

            &:hover {
              background: #4f46e5;
              color: #ffffff;
            }
          }

          &.btn_danger {
            background: rgba(239, 68, 68, 0.12);
            color: #dc2626;
            border: 1px solid rgba(239, 68, 68, 0.3);

            &:hover {
              background: #dc2626;
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  /* DIALOG CARDS */
  .custom_dialog_card {
    border-radius: 24px !important;
    overflow: hidden;

    .dialog_icon_box {
      width: 64px;
      height: 64px;
      border-radius: 20px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.75rem;

      &.icon_danger {
        background: rgba(239, 68, 68, 0.12);
        color: #ef4444;
      }

      &.icon_success {
        background: rgba(16, 185, 129, 0.12);
        color: #10b981;
      }

      &.icon_warning {
        background: rgba(245, 158, 11, 0.12);
        color: #f59e0b;
      }

      &.icon_info {
        background: rgba(99, 102, 241, 0.12);
        color: #6366f1;
      }
    }

    .custom_textarea,
    .custom_input {
      border-radius: 14px;
      border: 1px solid #e2e8f0;
      padding: 12px 16px;
      transition: all 0.2s ease;

      &:focus {
        border-color: #6366f1;
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
      }
    }
  }
}
</style>
